<template>
    <AddConfirmation
      ref="AddConfirmationModal"
      warnText="O relatório será enviado no seu e-mail"
      :saveFunction="confirm"
    />
</template>

<script>
import { toast, loading } from '@/shared/utils/UIHelper'

import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente.js'

import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'

const AcaoListaInteligenteData = {
  acaoListaInteligente: 'EXPORT_EXCEL'
}

export default {
  name: 'SendExcelEmailConfirmationModal',
  data () {
    return {
      data: AcaoListaInteligenteData,
      acaoListaId: null
    }
  },
  components: {
    AddConfirmation
  },
  methods: {
    openConfirmationModal (acaoListaId) {
      if (acaoListaId) {
        this.acaoListaId = acaoListaId
        this.$nextTick(() => {
          this.$refs['AddConfirmationModal'].showModal()
        })
      }
    },
    confirm () {
      if (this.acaoListaId) {
        loading.push()
        ListaInteligenteRepository.CreateAcao(this.acaoListaId, this.data)
          .then((response) => {
            if (response.status === 201) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.$emit('reloadAcoes')
            }
            loading.close()
          })
          .catch(this.onException)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/modal/SendExcelEmailConfirmationModal.vue